<template>
  <div>
    <p class="head-text">当前职业群：<span class="protrude">{{listCareer[0].category1}}</span>，<span v-if="this.mode=='explore'">选择你要从事的职业，</span>其中<span class="protrude">百分比数字为该职业与你的匹配度</span></p>
    <div class="career-category">
      <template v-for="(item,index) in listCareer">
        <p class="category-name">{{item.category2}}</p>
        <ul>
          <li class="category-content" v-for="(carrer,zindex) in item.listCareer" :class="item.listCareer[zindex].selected?'current':''" @click="selectCareer(carrer,index,zindex)">
            <template>
              <p class="left-side">{{carrer.careerName}}</p>
              <p class="right-side">{{carrer.iTotalScore}}%</p>
            </template>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>
<!--多答案-->
<script>
export default {
  props:{
    content:Array,
    selected:Array,
    mode: String
  },
  data(){
    return{
      listCareer:[]
    }
  },
  created(){
    this.listCareer = this.content
  },
  methods:{
    selectCareer(item,i,z){
      if (this.mode=='search'){
         return
      }
      let add=true;
      this.selected.map((carrer,index)=>{
        if(carrer.name==item.careerName){
          add = false
          this.$set(this.selected,index,'')
          item.selected=false
          this.$set(this.listCareer[i].listCareer,z,item)
        }
      })
      if(add){
        this.selected.map((carrer,index)=>{
          if(!carrer.name&&add){
            this.$set(this.selected,index,{name:item.careerName,score:item.iTotalScore,hollandPreThree:item.hollandPreThree})
            add=false
            item.selected=true
            this.$set(this.listCareer[i].listCareer,z,item)
          }
        })
      }
      this.$emit("listenToChildEvent",this.selected,this.listCareer)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .head-text
    text-align:center
    .protrude
      color:#DC6E5A
  .career-category
    overflow-y:auto
    margin:0.2rem 0.1rem
    .category-name
      background-color:#00B3DE
      color:#ffffff
      padding:0.1rem
      width:4rem
      margin:0.4rem auto 0.2rem auto
      text-align:center
    .category-content
      overflow:hidden
      max-width:8rem
      width: 80%
      color:#ffffff
      background-color:#787878
      margin:0.1rem auto
      padding:0.1rem 0.3rem
      border-radius:6px
    .current
      background-color:#cdcdcd
</style>
